import type { T360TagConfig } from './types';

export const T360_TAG_CONFIG: T360TagConfig = {
    classes: [
        {
            code: 'manu',
            name: 'Manufacturer document',
            facets: [
                { facet: 'oem', required: true, select: '1' },
                { facet: 'report_type', required: false, select: '0-*' },
                { facet: 'asset', required: false, select: '0-1' },
            ],
        },
        {
            code: 'arc',
            name: 'Authorised release certificate',
            facets: [
                { facet: 'arc_type', required: true, select: '1' },
                { facet: 'mro', required: false, select: '0-1' },
            ],
        },
        {
            code: 'coc',
            name: 'Certificate of conformity',
            facets: [
                { facet: 'vendor', required: false, select: '0-1' },
                { facet: 'oem', required: false, select: '0-1' },
            ],
        },
        {
            code: 'sl-tag',
            name: 'Serviceable label or tag',
            facets: [
                { facet: 'operator', required: false, select: '0-1' },
                { facet: 'mro', required: false, select: '0-1' },
                { facet: 'system', required: false, select: '0-1' },
            ],
        },
        {
            code: 'wo',
            name: 'Work order',
            facets: [
                { facet: 'work_type', required: true, select: '0-*' },
                { facet: 'mro', required: false, select: '0-1' },
                { facet: 'system', required: false, select: '0-1' },
                { facet: 'operator', required: false, select: '0-1' },
            ],
        },
        {
            code: 'shop-visit',
            name: 'Asset shop visit report',
            facets: [
                { facet: 'asset', required: true, select: '1' },
                { facet: 'mro', required: false, select: '0-1' },
                { facet: 'report_type', required: false, select: '0-*' },
                { facet: 'oem', required: false, select: '0-1' },
            ],
        },
        {
            code: 'status-report',
            name: 'Status report',
            facets: [
                { facet: 'report_type', required: true, select: '1' },
                { facet: 'mro', required: false, select: '0-1' },
                { facet: 'operator', required: false, select: '0-1' },
                { facet: 'system', required: false, select: '0-1' },
                { facet: 'asset', required: false, select: '0-1' },
            ],
        },
        {
            code: 'ad',
            name: 'Airworthiness directive',
            facets: [
                { facet: 'authority', required: true, select: '1' },
                { facet: 'asset', required: false, select: '0-1' },
                { facet: 'oem', required: false, select: '0-1' },
            ],
        },
        {
            code: 'sb',
            name: 'Service bulletin',
            facets: [
                { facet: 'oem', required: false, select: '0-1' },
                { facet: 'vendor', required: false, select: '0-1' },
                { facet: 'asset', required: false, select: '0-1' },
                { facet: 'part21', required: false, select: '0-1' },
            ],
        },
        {
            code: 'mpd',
            name: 'Maintenance planning document',
            facets: [{ facet: 'oem', required: true, select: '1' }],
        },
        {
            code: 'amp',
            name: 'Aircraft maintenance programme',
            facets: [{ facet: 'operator', required: true, select: '1' }],
        },
        {
            code: 'job-card',
            name: 'Job card',
            facets: [
                { facet: 'mro', required: false, select: '0-1' },
                { facet: 'system', required: false, select: '0-1' },
                { facet: 'operator', required: false, select: '0-1' },
            ],
        },
        {
            code: 'eo',
            name: 'Engineering order',
            facets: [
                { facet: 'operator', required: false, select: '0-1' },
                { facet: 'system', required: false, select: '0-1' },
                { facet: 'part21', required: false, select: '0-1' },
            ],
        },
        {
            code: 'afm',
            name: 'Aircraft flight manual',
            facets: [
                { facet: 'operator', required: false, select: '0-1' },
                { facet: 'oem', required: false, select: '0-1' },
            ],
        },
        {
            code: 'comp-shop',
            name: 'Component shop report',
            facets: [
                { facet: 'mro', required: false, select: '0-1' },
                { facet: 'oem', required: false, select: '0-1' },
            ],
        },
        {
            code: 'crs',
            name: 'Certificate of release to service',
            facets: [
                { facet: 'operator', required: false, select: '0-1' },
                { facet: 'mro', required: false, select: '0-1' },
                { facet: 'system', required: false, select: '0-1' },
                { facet: 'authority', required: false, select: '0-1' },
            ],
        },
        {
            code: 'task-card',
            name: 'Task card',
            facets: [
                { facet: 'work_type', required: false, select: '0-1' },
                { facet: 'mro', required: false, select: '0-1' },
                { facet: 'system', required: false, select: '0-1' },
                { facet: 'operator', required: false, select: '0-1' },
                { facet: 'oem', required: false, select: '0-1' },
            ],
        },
        {
            code: 'check-sheet',
            name: 'Single check sheet',
            facets: [
                { facet: 'operator', required: false, select: '0-1' },
                { facet: 'system', required: false, select: '0-1' },
            ],
        },
        {
            code: 'repair',
            name: 'Repair approval',
            facets: [
                { facet: 'oem', required: false, select: '0-1' },
                { facet: 'mro', required: false, select: '0-1' },
            ],
        },
        {
            code: 'tsm',
            name: 'Troubleshooting manual',
            facets: [{ facet: 'oem', required: true, select: '1' }],
        },
        {
            code: 'amm',
            name: 'Aircraft maintenance manual',
            facets: [{ facet: 'oem', required: true, select: '1' }],
        },
        {
            code: 'ipc',
            name: 'Illustrated parts catalogue',
            facets: [{ facet: 'oem', required: true, select: '1' }],
        },
        {
            code: 'srm',
            name: 'Structural repair manual',
            facets: [{ facet: 'oem', required: true, select: '1' }],
        },
        {
            code: 'stc',
            name: 'Supplemental type certificate',
            facets: [
                { facet: 'vendor', required: false, select: '0-1' },
                { facet: 'authority', required: false, select: '0-1' },
            ],
        },
        {
            code: 'tech-log',
            name: 'Tech log',
            facets: [
                { facet: 'operator', required: false, select: '0-1' },
                { facet: 'system', required: false, select: '0-1' },
                { facet: 'log_type', required: false, select: '0-1' },
            ],
        },
        {
            code: 'flight-log',
            name: 'Flight log',
            facets: [
                { facet: 'operator', required: false, select: '0-1' },
                { facet: 'system', required: false, select: '0-1' },
            ],
        },
        {
            code: 'ddr',
            name: 'Deferred defect',
            facets: [
                { facet: 'operator', required: false, select: '0-1' },
                { facet: 'system', required: false, select: '0-1' },
            ],
        },
        {
            code: 'cmm',
            name: 'Component maintenance manual',
            facets: [
                { facet: 'vendor', required: false, select: '0-1' },
                { facet: 'oem', required: false, select: '0-1' },
            ],
        },
        {
            code: 'asset-mm',
            name: 'Asset maintenance manual',
            facets: [
                { facet: 'oem', required: false, select: '0-1' },
                { facet: 'asset', required: false, select: '0-1' },
            ],
        },
    ],
    facets: [
        {
            key: 'oem',
            name: 'OEM',
            values: {
                airbus: 'Airbus',
                boeing: 'Boeing',
                bombardier: 'Bombardier',
                embraer: 'Embraer',
                comac: 'COMAC',
                cfm: 'CFM International',
                ge: 'GE Aerospace',
                'pratt-whitney': 'Pratt & Whitney',
                iae: 'International Aero Engines',
                'rolls-royce': 'Rolls-Royce',
                honeywell: 'Honeywell',
                safran: 'Safran',
                collins: 'Collins Aerospace',
                liebherr: 'Liebherr Aerospace',
                parker: 'Parker Aerospace',
                thales: 'Thales',
                meggitt: 'Meggitt',
                woodward: 'Woodward',
                other: 'Other',
            },
            vocab: 'closed',
            select: '0-1',
        },
        {
            key: 'asset',
            name: 'Asset',
            values: {
                aircraft: 'Aircraft',
                eng: 'Engine',
                apu: 'APU',
                lg: 'Landing gear',
                other: 'Other',
            },
            vocab: 'closed',
            select: '0-1',
        },
        {
            key: 'arc_type',
            name: 'ARC type',
            values: {
                form1: 'EASA Form 1',
                faa: 'FAA 8130-3',
                caac: 'CAAC',
                caa: 'UK CAA',
                dual: 'Dual',
                tcca: 'TCCA',
                casa: 'CASA',
                anac: 'ANAC',
                caam: 'CAAM',
                caas: 'CAAS',
                shgm: 'Turkish DGCA (SHGM)',
                other: 'Other',
            },
            vocab: 'closed',
            select: '0-1',
        },
        {
            key: 'work_type',
            name: 'Work type',
            values: {
                sch: 'Scheduled',
                nrc: 'Non-routine',
            },
            vocab: 'closed',
            select: '0-*',
        },
        {
            key: 'log_type',
            name: 'Tech log',
            values: {
                pilot: 'Pilot',
                cabin: 'Cabin',
                'pilot-cabin': 'Pilot and cabin',
                marep: 'MAREP',
            },
            vocab: 'closed',
            select: '0-1',
        },
        {
            key: 'report_type',
            name: 'Report',
            values: {
                ad: 'AD',
                occm: 'OCCM',
                ht: 'Hard time',
                comp: 'Components',
                llp: 'LLP',
                b2b: 'Back to birth',
                sb: 'SB',
                mod: 'Modifications',
                stc: 'STC',
                damage: 'Damage',
                utilisation: 'Utilisation',
            },
            vocab: 'closed',
            select: '0-*',
        },
        {
            key: 'authority',
            name: 'Authority',
            values: {
                faa: 'FAA',
                easa: 'EASA',
                tcca: 'TCCA',
                caac: 'CAAC',
                caam: 'CAAM',
                caa: 'UK CAA',
                jcab: 'JCAB',
            },
            vocab: 'closed',
            select: '0-1',
        },
        {
            key: 'operator',
            name: 'Operator',
            values: {
                flyplay: 'Fly Play',
                'aer-lingus': 'Aer Lingus',
                'china-express': 'China Express Airlines',
                airbaltic: 'airBaltic',
                spirit: 'Spirit Airlines',
                airasia: 'AirAsia',
                interjet: 'Interjet',
                'china-eastern': 'China Eastern',
                'wizz-air': 'Wizz Air',
                'austrian-airlines': 'Austrian Airlines',
                'air-canada': 'Air Canada',
                lot: 'LOT Polish Airlines',
                avianca: 'Avianca',
                egyptair: 'EgyptAir',
                united: 'United Airlines',
                'trans-states': 'Trans States Airlines',
            },
            vocab: 'open',
            select: '0-1',
        },
        {
            key: 'mro',
            name: 'MRO',
            values: {
                dal: 'DAL',
                sabena: 'Sabena',
                'ce-maintenance': 'CE Maintenance',
                'job-air-technic': 'Job Air Technic',
                gmt: 'GMT',
                'lufthansa-technik': 'Lufthansa Technik',
                standardaero: 'StandardAero',
                airbaltic: 'airBaltic',
                ade: 'Asia Digital Engineering',
                sepang: 'Sepang Aircraft Engineering',
                'eme-aero': 'EME Aero',
                mtu: 'MTU Maintenance',
                iberia: 'Iberia Maintenance',
                'austrian-technik': 'Austrian Technik',
                'eastern-airlines-technic': 'Eastern Airlines Technic',
                huatai: 'Chengdu Huatai Aviation',
                xinli: 'Sichuan Xinli Aero-Technology',
                huasheng: 'Yunnan Huasheng Aviation',
                xiangyu: 'Shandong Xiangyu Aviation',
                gameco: 'GAMECO',
                'ge-engine-services': 'GE Engine Services',
                landlocked: 'Landlocked Aviation Services',
                'citadel-completions': 'Citadel Completions',
                ihi: 'IHI',
                'ls-technics': 'LS Technics',
                'storm-aviation': 'Storm Aviation',
                'turkish-technic': 'Turkish Technic',
                'shanghai-pratt-whitney': 'Shanghai Pratt & Whitney',
                samco: 'SAMCO',
                aersale: 'AerSale',
                'tp-aerospace': 'TP Aerospace',
                'magnetic-mro': 'Magnetic MRO',
                'christchurch-engine-centre': 'Christchurch Engine Centre',
                collins: 'Collins Aerospace',
                liebherr: 'Liebherr Aerospace',
                honeywell: 'Honeywell',
                safran: 'Safran',
                thales: 'Thales',
                parker: 'Parker Aerospace',
            },
            vocab: 'open',
            select: '0-1',
        },
        {
            key: 'system',
            name: 'Maintenance system',
            values: {
                amos: 'AMOS',
                sap: 'SAP',
                gannet: 'Gannet',
                oases: 'OASES',
                amasis: 'AMASIS',
                amis: 'AMIS',
                trax: 'TRAX',
                corridor: 'CORRIDOR',
            },
            vocab: 'open',
            select: '0-1',
        },
        {
            key: 'vendor',
            name: 'Vendor',
            values: {
                recaro: 'Recaro',
                satair: 'Satair',
                'boeing-distribution': 'Boeing Distribution',
                proponent: 'Proponent',
                'seal-dynamics': 'Seal Dynamics',
                chemetall: 'Chemetall',
                'leki-aviation': 'Leki Aviation',
                topcast: 'Topcast Aviation Supplies',
                'pdq-airspares': 'PDQ Airspares',
                akzonobel: 'AkzoNobel',
                ppg: 'PPG Aerospace',
                henkel: 'Henkel',
                wencor: 'Wencor',
                aerotron: 'Aerotron',
                avair: 'AvAir',
            },
            vocab: 'open',
            select: '0-1',
        },
        {
            key: 'part21',
            name: 'Part 21',
            values: {
                '3rd-party-design': '3rd party design',
            },
            vocab: 'closed',
            select: '0-1',
        },
    ],
    combined: [
        ['tech-log', 'flight-log'],
        ['task-card', 'wo'],
    ],
};
